import { render, staticRenderFns } from "./chainInfoMiddle.vue?vue&type=template&id=723d16ae&scoped=true&"
import script from "./chainInfoMiddle.vue?vue&type=script&lang=js&"
export * from "./chainInfoMiddle.vue?vue&type=script&lang=js&"
import style0 from "./chainInfoMiddle.vue?vue&type=style&index=0&id=723d16ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d16ae",
  null
  
)

export default component.exports